export default __webpack_public_path__ + "static/Wald-Saege_Fuchstal_Schriftzug-d238333c82a1412ab369c42a101a5bc6.png";